import { createCacheStore } from '@lib/utils/cache';
import { OrgUserService } from '@api/OrgUserService';

/** Cached OrgUserService.getOrgUsers(orgId) reads. */
export const orgUsersCache = createCacheStore(
    'orgUser/users',
    OrgUserService.getOrgUsers,
);

/** Drops all cached org user data (after user mutations, full clears). */
export const invalidateOrgUserData = (): void => {
    orgUsersCache.invalidateAll();
};
